import { forwardRef } from "react";
import CustomScrollbars from "components/CustomScrollbars";
import { strongAutocompletePaperProps } from "components/common/dropdownPaper";

export const autocompleteScrollPaperProps = strongAutocompletePaperProps;

export const AutocompleteScrollListbox = forwardRef<
  HTMLUListElement,
  React.HTMLAttributes<HTMLUListElement>
>(function AutocompleteScrollListbox({ children, ...listboxProps }, ref) {
  return (
    <CustomScrollbars
      ref={ref}
      variant="compact"
      scrollableElement="ul"
      preserveScrollOnGrow
      scrollableProps={listboxProps}
      trackOffsetTop={10}
      trackOffsetBottom={10}
      sx={{ width: "100%", minWidth: 0 }}
    >
      {children}
    </CustomScrollbars>
  );
});
